import React, { useContext } from 'react';
import { ICreateModifierContext, CreateModifierContext } from '../../../../createModifierState/createModifierContext';
import FormImageUploader from 'components/FormImageUploader/FormImageUploader';
import InputFields from './InputFields/InputFields';
import classNames from 'classnames';
import style from './CreationForm.module.scss';

const descriptionOfAspectRatio = {
	horizontal: {
		ratio: '95:46',
		optimalResolutions: {
			a: '380*184px',
			b: '760*368px',
		},
	},
	vertical: {
		ratio: '44:19',
		optimalResolutions: {
			a: '528*228px',
			b: '1056*456px',
		},
	},
};

interface IProps {
	isVisible: boolean;
}

const CreationForm: React.FC<IProps> = ({ isVisible }) => {
	const { setFileId, fileId } = useContext<ICreateModifierContext>(CreateModifierContext);
	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	const deletePhotoHandler = () => {
		setFileId(null);
	};

	return (
		<div className={containerClasses} data-test="CreationForm">
			<FormImageUploader
				containerClass={style.imageUploader}
				maxFileSizeMB={1}
				fileId={fileId}
				setFileId={setFileId}
				deletePhotoHandler={deletePhotoHandler}
				horizontalAspectRatio={380 / 184}
				verticalAspectRatio={528 / 228}
				descriptionOfAspectRatio={descriptionOfAspectRatio}
			/>
			<InputFields />
		</div>
	);
};

export default CreationForm;
